'use strict';

/** @type {import('./Reflect.setPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.setPrototypeOf) || null;



/*****************
 ** WEBPACK FOOTER
 ** ./~/set-proto/Reflect.setPrototypeOf.js
 ** module id = 1633
 ** module chunks = 0
 **/